import { FieldArray, FormikProps } from 'formik'
import React, { useState } from 'react'
import { MdAdd } from 'react-icons/md';
import { InputField } from 'src/components/common/formFields';
import Label from 'src/components/common/formFields/label/Label';
import MultiSelectField from 'src/components/common/formFields/multiSelectField/MultiSelectField'
import ToggleSwitch2 from 'src/components/common/toggle-switch-version2/ToggleSwitchV2';
import { componentSizeVariantsEnum } from 'src/constants';
import cx from '../common/cofonderdropdown.module.scss';
import SelectField from 'src/components/common/formFields/selectField/SelectField';
import TextArea from 'src/components/common/formFields/textArea/TextArea';
import UploadField from '../upload-field/UploadField';
import { useAppDispatch } from 'src/store/hooks';
import { openPopup } from 'src/store/common/common.slice';
import handleExtension from 'src/utils/handleDocumentNameExtension/handleDocumentNameExtension';
import { TUploadCompanyProfilePictureResponse } from 'src/services/apiEndpoint.types.ts';
import { APIResponse } from 'src/services/base.api.service';
import { CompanyAPIService } from 'src/services/company.service';
import { VentureAPIService } from 'src/services/venture.service';
import { useUrlParamValue } from 'src/hooks';
import up from './common.module.scss'
import imageCompresser from 'src/components/common/image-compresser/imageCompresser';

export default function Branding({ values, setFieldValue, touched, errors }: FormikProps<any>) {
  const dispatch = useAppDispatch();
  const { paramValue } = useUrlParamValue();
  const id: string = paramValue({ paramName: 'id' }) as string;
  const [uploadLoading, setUploadLoading] = useState<string>('')
  const domains: { label: string; value: string; id: string }[] = [
    { label: "Technology", value: "Technology", id: "Technology" },
    { label: "Marketing", value: "Marketing", id: "Marketing" },
    { label: "Operations", value: "Operations", id: "Operations" },
    { label: "Finance", value: "Finance", id: "Finance" },
    { label: "Sales", value: "Sales", id: "Sales" },
    { label: "HR", value: "HR", id: "HR" },
    { label: "Strategy", value: "Strategy", id: "Strategy" }
  ];

  async function handleUpload(files: string | ArrayBuffer | null | any, type: string) {
    const file = files[0];
    if (!file?.type?.includes('image')) {
      dispatch(
        openPopup({
          popupMessage: 'Please select valid image file',
          popupType: 'error'
        })
      );
      return
    }
    setUploadLoading(type)
    if (file) {
      const compressedFile = await imageCompresser(file, 0.7);
      const fileName = handleExtension(compressedFile?.name?.replaceAll(/\s+/g, ''));

      const reader = new FileReader();
      reader.readAsArrayBuffer(compressedFile);
      reader.onload = async () => {
        try {
          const data = reader.result;
          const response: any = await new VentureAPIService().getPresignedUrl({ ventureVerseId: id, fileName, fileType: type })
          if (response?.data?.data?.signedUrl) {
            const res: APIResponse<TUploadCompanyProfilePictureResponse> | any =
              await new CompanyAPIService().uploadCompanyProfilePicture({
                presignedUrl: response?.data?.data?.signedUrl,
                data,
                includeAuthorizationHeaders: false
              });
            if (res.status === 200) {
              const data: any = await new VentureAPIService().getPresignedUrl({ ventureVerseId: id, fileName, fileType: type })
              if (data?.data?.data?.key) {
                // setFieldValue('banner', { url: data?.data?.key, height: '500px', width: '100%' })
                setFieldValue(type, data?.data?.data?.key)
              } else {
                dispatch(
                  openPopup({
                    popupMessage: 'something went wrong',
                    popupType: 'error'
                  })
                );
              }
              setUploadLoading('')
            } else {
              dispatch(
                openPopup({
                  popupMessage: res?.message || 'something went wrong',
                  popupType: 'error'
                })
              );
            }
          } else {
            setUploadLoading('')
            dispatch(
              openPopup({
                popupMessage: 'something went wrong',
                popupType: 'error'
              })
            );
          }
        } catch (error) {
          setUploadLoading('')
          dispatch(
            openPopup({
              popupMessage: error?.message || 'something went wrong',
              popupType: 'error'
            })
          );
        }
      }
    }
  }
  const coFounderHiringArr = values.hiring.filter((item) => item.title === 'Co-Founder');
  const filteredHiring = values.hiring.filter((item) => item.title !== 'Co-Founder');
  const modifiedHiring = filteredHiring.length > 0 ? filteredHiring : [...filteredHiring, { domain: "", title: "", description: "" }];
  const coFounderHiring = values.hiring.find((item) => item.title === 'Co-Founder');
  console.log(filteredHiring, 'coFounderHiring', coFounderHiring, modifiedHiring, coFounderHiringArr, values.hiring);

  return (
    <>
      <MultiSelectField
        id="hiring"
        variant={componentSizeVariantsEnum.SMALL}
        selectedValues={coFounderHiringArr.flatMap((item) => item.domain.split(', '))}
        component={
          <ToggleSwitch2
            id="isSeekingCofounderHiring"
            color={values.isSeekingCofounderHiring ? '#fff' : '#bbb6b2'}
            checked={values.isSeekingCofounderHiring}
            onChange={(e) => setFieldValue('isSeekingCofounderHiring', e.target.checked)}
          />
        }
        onSelection={({ selectedValues }) => {
          let hiring = [...values.hiring];
          if (coFounderHiringArr.length === 0) {
            hiring.unshift({ title: 'Co-Founder', domain: selectedValues ? selectedValues.join(', ') : '' })
          } else {
            hiring = hiring.map((item) => {
              if (item.title === 'Co-Founder') {
                console.log(item, 'itemdatatatatatata');

                return { ...item, domain: selectedValues ? selectedValues.join(', ') : '' }
              }
              return item
            })
          }
          if (selectedValues?.length === 0) {
            hiring = hiring?.filter((item) => item?.title !== 'Co-Founder')
          }
          console.log(hiring, 'hiring');

          setFieldValue('hiring', hiring)
        }}
        options={domains}
        style={{ marginTop: '-5px' }}
        label="Seeking Co-Founder"
        placeholder="Domains"
      />
      <TextArea
        textAreaStyle={{ width: '100%' }}
        placeholder="Job Description"
        value={coFounderHiring?.description || ''}
        onChange={(e) => {
          const value = e.target.value;
          let hiring = [...values.hiring];
          if (coFounderHiringArr.length === 0) {
            hiring.unshift({ title: 'Co-Founder', domain: '', description: value })
          } else {
            hiring = hiring.map((item) => {
              if (item.title === 'Co-Founder') {
                return { ...item, description: value }
              }
              return item
            })
          }
          setFieldValue('hiring', hiring)
        }}
      />

      <FieldArray name="hiring">
        {({ push, remove }) => (
          modifiedHiring.map((item, i: number) => {
            if (item.title === 'Co-Founder') return null;
            const modifiedIndex = i + coFounderHiringArr?.length

            return (
              <div key={modifiedIndex}>
                <div className="d-flex justify-content-between mb-3">
                  <Label variant={componentSizeVariantsEnum.MEDIUM}>Hiring</Label>
                  <div className="d-flex gap-2">
                    <span
                      className={cx.actionButton}
                      onClick={() => {
                        if (modifiedIndex === coFounderHiringArr.length) {
                          push({ domain: "", title: "", description: '' });
                        } else {
                          remove(modifiedIndex);
                        }
                      }}
                    >
                      {modifiedIndex === coFounderHiringArr.length ? (
                        <>
                          <MdAdd className={cx.icon} /> Add
                        </>
                      ) : (
                        'Remove'
                      )}
                    </span>
                    {i === 0 && (
                      <ToggleSwitch2
                        id="isHiring"
                        color={values.isHiring ? '#fa4616' : '#bbb6b2'}
                        checked={values.isHiring}
                        onChange={(e) => setFieldValue('isHiring', e.target.checked)}
                      />
                    )}
                  </div>
                </div>
                <InputField
                  id={`hiring`}
                  elementtype='program-creation'
                  value={values.hiring[modifiedIndex]?.title || ""}
                  variant={componentSizeVariantsEnum.SMALL}
                  placeholder="Job Title"
                  type="text"
                  required
                  isTouched={touched.hiring?.[modifiedIndex]?.title}
                  errorMessage={errors.hiring?.[modifiedIndex]?.title}
                  onChange={(e) => setFieldValue(`hiring.${modifiedIndex}.title`, e.target.value)}
                />
                <SelectField
                  style={{ margin: '10px 0' }}
                  options={domains}
                  placeholder="Domain"
                  label=""
                  selectedValue={values.hiring[modifiedIndex]?.domain}
                  onSelection={(e) => setFieldValue(`hiring.${modifiedIndex}.domain`, e.value)}
                  errorMessage={errors.hiring?.[modifiedIndex]?.domain}
                  isTouched={touched.hiring?.[modifiedIndex]?.domain}
                />
                <TextArea
                  textAreaStyle={{ width: '100%' }}
                  placeholder="Job Description"
                  value={values.hiring[modifiedIndex]?.description || ""}
                  onChange={(e) => setFieldValue(`hiring.${modifiedIndex}.description`, e.target.value)}
                />
              </div>
            );
          })
        )}
      </FieldArray>

      {/* logo  */}
      {values.logo && <Label variant={componentSizeVariantsEnum.SMALL}>
        <span>Logo</span>
      </Label>}
      {!values.logo && <UploadField title='Logo' loading={uploadLoading === 'logo'} instructionText='Recommended image dimension  is 100x100' onUpload={(data) => handleUpload(data, 'logo')} />}
      {values.logo && <div className={`${up.uploadImage}`}>
        <button style={{ position: 'absolute', top: '10px', right: '10px', background: '#fff', height: '23px', fontSize: '14px', width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: 'none', color: 'red' }} onClick={() => setFieldValue('logo', '')}>
          X
        </button>
        <img src={values.logo} alt="logo" />
      </div>}

      {values.banner && <Label variant={componentSizeVariantsEnum.SMALL}>
        <span>Banner</span>
      </Label>}
      {!values.banner && <UploadField title='Banner' loading={uploadLoading === 'banner'} instructionText='Recommended image dimension  is 1920x1080' onUpload={(data) => handleUpload(data, 'banner')} />}
      {values.banner && <div className={`${up.uploadImage2}`}>
        <button style={{ position: 'absolute', top: '10px', right: '10px', background: '#fff', height: '23px', fontSize: '14px', width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: 'none', color: 'red' }} onClick={() => setFieldValue('banner', '')}>
          X
        </button>
        <img src={values.banner} alt="banner" />
      </div>}

    </>
  )
}
